__turbopack_context__.v({
  "balance": "creation-navigation-module__CCnTKG__balance",
  "bar": "creation-navigation-module__CCnTKG__bar",
  "indicator": "creation-navigation-module__CCnTKG__indicator",
  "navigation": "creation-navigation-module__CCnTKG__navigation",
  "track": "creation-navigation-module__CCnTKG__track",
  "works": "creation-navigation-module__CCnTKG__works",
});
